import React from "react";
import { Target, Eye, Heart, Award } from "lucide-react";
import { stats, company } from "../mock";
import { PageHeader } from "./Contatti";

const values = [
  { Icon: Target, title: "Mission", text: "Fornire prodotti e servizi di qualità per supportare la crescita dei nostri clienti professionali." },
  { Icon: Eye, title: "Vision", text: "Essere il partner di riferimento per ferramenta, antinfortunistica e servizi industriali nel Nord-Est." },
  { Icon: Heart, title: "Valori", text: "Affidabilità, trasparenza e attenzione alle esigenze del cliente in ogni fase del servizio." },
  { Icon: Award, title: "Qualità", text: "Selezione rigorosa dei brand e controllo qualità su ogni fornitura per garantire il massimo standard." },
];

const ChiSiamo = () => (
  <>
    <PageHeader title="Chi siamo" subtitle={`${company.name} è il tuo partner per la fornitura di prodotti professionali e servizi industriali a Treviso e nel Veneto.`} />
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <img src="https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Metal Solutions" className="rounded-2xl shadow-xl" />
          <div className="absolute -bottom-6 -right-6 bg-[#00A859] text-white p-6 rounded-2xl shadow-2xl hidden md:block">
            <div className="text-4xl font-extrabold">15+</div>
            <div className="text-xs uppercase tracking-wider font-semibold">Anni di esperienza</div>
          </div>
        </div>
        <div>
          <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">La nostra storia</span>
          <h2 className="text-4xl font-extrabold text-[#0B2545] tracking-tight mb-5">Esperienza, qualità e servizio</h2>
          <p className="text-gray-600 leading-relaxed mb-4">Metal Solutions S.R.L. è una realtà consolidata nel commercio di prodotti per la ferramenta, utensileria, antinfortunistica e materiale ferroso. La nostra sede di Paese (TV) e il deposito di Pieve del Grappa ci permettono di servire con efficienza tutto il Nord-Est italiano.</p>
          <p className="text-gray-600 leading-relaxed mb-4">Oltre alla fornitura di prodotti, offriamo servizi completi di manutenzione, pulizia, portierato e facchinaggio per aziende e complessi industriali.</p>
          <p className="text-gray-600 leading-relaxed">La nostra squadra è composta da professionisti qualificati che ogni giorno mettono passione e competenza al servizio dei clienti.</p>
        </div>
      </div>
    </section>

    <section className="py-20 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">I nostri valori</span>
          <h2 className="text-4xl font-extrabold text-[#0B2545] tracking-tight">Cosa ci guida ogni giorno</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl p-7 border border-gray-100 hover:border-[#00A859] hover:shadow-md transition-all">
              <div className="w-12 h-12 rounded-xl bg-[#00A859]/10 flex items-center justify-center mb-4">
                <v.Icon className="w-6 h-6 text-[#00A859]" />
              </div>
              <h3 className="font-bold text-lg text-[#0B2545] mb-2">{v.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-20 bg-[#0B2545] text-white">
      <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s) => (
          <div key={s.label} className="text-center">
            <div className="text-5xl md:text-6xl font-extrabold text-[#00A859] mb-2">{s.value}</div>
            <div className="text-sm text-gray-300 uppercase tracking-wider font-semibold">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  </>
);

export default ChiSiamo;
